import LogoMark from '@/src/components/LogoMark';
import { useAppColors } from '@/src/lib/theme';

/**
 * Full "icon + wordmark" lockup, rebuilt inline instead of the old
 * /logo-full.png — that was a static image baked white-on-transparent,
 * so it went invisible the moment the page background went light (same
 * root cause as the /logo-icon.png issue fixed elsewhere). This version
 * recolours itself from the active theme.
 */
export default function OpsAloLogo({ className = '' }: { className?: string }) {
  const c = useAppColors();
  // TopBar is h-14 (56px) tall — 42px leaves comfortable margin above/below.
  const height = 48;

  return (
    <div className={`flex items-center gap-2 ${className}`} style={{ height }}>
      <LogoMark size={height} color={c.text} />
      <span
        style={{
          fontFamily: "'Fredoka', 'Inter', sans-serif",
          fontWeight: 400,
          fontSize: height * 0.40,
          color: c.text,
          lineHeight: 1,
        }}
      >
        OpsAlo
      </span>
    </div>
  );
}